import { render, staticRenderFns } from "./SalariumReminderModal.vue?vue&type=template&id=1f8956c3&"
import script from "./SalariumReminderModal.vue?vue&type=script&lang=js&"
export * from "./SalariumReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./SalariumReminderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports